import { Component, Input } from '@angular/core';
import {
  CompetitionData,
  CompetitionDetails,
  CompetitionInfo,
} from './../../../../data/mygolf.data';
import { PlayerInfo } from './../../../../data/player-data';
import { PaymentService } from './../../../../providers/payment-service/payment-service';
import {
  NavParams,
  ModalController,
  ToastController,
  LoadingController,
  Platform,
} from '@ionic/angular';

import {
  InAppBrowser,
  InAppBrowserOptions,
  InAppBrowserEvent,
} from '@awesome-cordova-plugins/in-app-browser/ngx';
// import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';

import { PaymentDetails, PlayerPaid } from './../../../../data/payment-bill';
import { MessageDisplayUtil } from 'src/message-display-utils';

// import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
@Component({
  templateUrl: 'competition-payment-confirmation.html',
  selector: 'competition-payment-confirmation-page',
  styleUrls: ['./competition-payment-confirmation.scss'],
})
export class CompetitionPaymentConfirm {
  competition: CompetitionInfo;
  details: CompetitionDetails;
  player: PlayerInfo;
  toggleRegister: boolean = false;

  compCollectionId: string;
  paidBillId: string;
  paymentStatus: string = 'pending';

  getCollSuccess: boolean = false;

  options: any = {
    //InAppBrowserOptions = {
    location: 'yes', //Or 'no'
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes', //Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only
    toolbar: 'yes', //iOS only
    enableViewportScale: 'no', //iOS only
    allowInlineMediaPlayback: 'no', //iOS only
    presentationstyle: 'pagesheet', //iOS only
    fullscreen: 'yes', //Windows only
  };

  iab: any;

  @Input() compData: CompetitionData;
  @Input() compPlayerId: number;
  constructor(
    private viewCtrl: ModalController,
    private navParams: NavParams,
    // private iab: InAppBrowser,
    private toastCtl: ToastController,
    private loadingCtl: LoadingController,
    private paymentService: PaymentService,
    private platform: Platform
    // private iab: InAppBrowser,
  ) {
    this.viewCtrl = viewCtrl;
    this.navParams = navParams;
    this.competition = this.navParams.get('competition');
    this.details = this.navParams.get('details');
    this.player = this.navParams.get('player');

    if (this.competition.competitionId)
      this.getCompetitionCollection(this.competition.competitionId);
  }

  close() {
    this.viewCtrl.dismiss();
  }

  goRegister() {
    let paymentURL = this.details.paymentUrl;
    window.open(paymentURL, '_self');
  }

  goPaidRegister() {
    this.viewCtrl.dismiss({
      paid: this.paymentStatus,
      success: true,
    });
  }

  onCompCollClick() {
    this.getCompetitionCollection(this.competition.competitionId);
  }

  async createRemoteBill(collectionId?: string) {
    let _collectionId: string;
    if (collectionId) _collectionId = collectionId;
    else _collectionId = this.compCollectionId;

    let loader = await this.loadingCtl.create({
      message: 'Procesing Payment...',
      showBackdrop: false,
    });

    loader.present().then(() => {
      this.paymentService.createRemoteBill(collectionId).subscribe(
        (data: any) => {
          loader.dismiss().then(() => {
            if (data.url) {
              if (this.platform.is('capacitor')) {
                this.openWithInAppBrowser(data.url);
              }
              // this.openWithCordovaBrowser(data.url);
              else window.open(data.url, '_system');
            }
            if (data) {
              this.paidBillId = data.id;
              let intervalId = setInterval(() => {
                if (this.paymentStatus.toLowerCase() !== 'paid') this.getBill(this.paidBillId);
                else clearInterval(intervalId);
              }, 5000);
            }
          });
        },
        error => {
          if (loader) loader.dismiss().then(() => {});
        },
        () => {
          if (loader) loader.dismiss().then(() => {});
        }
      );
    });
  }

  async createBill(collectionId?: string) {
    let _collectionId: string;
    if (collectionId) _collectionId = collectionId;
    else _collectionId = this.compCollectionId;

    let loader = await this.loadingCtl.create({
      message: 'Procesing Payment...',
      showBackdrop: false,
    });

    let playerPaid: PlayerPaid = {
      player_id: this.player.playerId,
    };

    let paymentDetails: any = {
      collection_id: collectionId,
      amount: Number(this.compData?.competitionRegistrationFee) * 100, //! 77 * 100,
      email: this.player.email,
      name: this.player.playerName,
      mobile: this.player.phone,
      description: 'Registering for Competition ' + this.competition.competitionId,
      currency: 'MYR',
      paid_by: this.player.userId,
      player: {
        player_id: this.player.playerId,
        // "competition_id": this.competition.competitionId
      },
      // "paid_for": {
      //   "player_id": this.player.playerId
      // },
      // "competition_id": this.competition.competitionId,
      callback_url: 'http://devlet.mygolf2u.com/rest/payment/callback',
      redirect_url: 'http://m.mygolf2u.com/test/payment_redirect.html',
      bill_type: 'competition_player',
      bill_type_id: this.compPlayerId, // this.competition.competitionId,
    };
    setTimeout(() => {
      loader.dismiss().then(() => {});
    }, 300000);

    loader.present().then(() => {
      this.paymentService.createBill(_collectionId, paymentDetails).subscribe((data: any) => {
        loader.dismiss().then(
          () => {
            if (data) {
              this.paidBillId = data.id;
            }
            if (data.url) {
              if (this.platform.is('capacitor')) {
                this.openWithInAppBrowser(data.url);
              } else {
                // this.openWithCordovaBrowser(data.url);
                let win = window.open(data.url, '_system');
                win.onunload = function () {};
              }
            }
            if (data) {
              this.paidBillId = data.id;

              let intervalId = setInterval(() => {
                if (this.paymentStatus.toLowerCase() !== 'paid') this.getBill(this.paidBillId);
                else clearInterval(intervalId);
              }, 5000);
            }
          },
          error => {
            if (error) {
              let _error = error.json();
              if (_error.status === '500' || _error.status === '404') {
                MessageDisplayUtil.showMessageToast(
                  'Server Unreachable',
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
              } else if (_error.status === 500 || _error.status === 404) {
                MessageDisplayUtil.showMessageToast(
                  'Server Unreachable',
                  this.platform,
                  this.toastCtl,
                  3000,
                  'bottom'
                );
              }
            }
          }
        );
      });
    });
  }
  getCollections() {
    // this.paymentService.getCollections()
    // .subscribe((data:any)=> {
    // });
  }

  getRemoteCollections(collectionId?: string) {
    this.paymentService.getRemoteCollections().subscribe((data: any) => {});
  }

  getLocalCollections(collectionId?: string) {
    this.paymentService.getLocalCollections(collectionId).subscribe((data: any) => {});
  }

  getBill(billId?: string) {
    this.paymentService.getBill(billId).subscribe((data: any) => {
      if (data.state.toLowerCase() === 'paid') {
        this.toggleRegister = true;
        this.paymentStatus = 'Paid';
      } else if (data.state.toLowerCase() === 'due') {
        this.paymentStatus = 'Due';
        this.toggleRegister = false;
      } else this.toggleRegister = false;
    });
  }

  getCompetitionCollection(competitionId?: number) {
    this.paymentService.getCompCollection(competitionId).subscribe((data: any) => {
      if (data) {
        this.compCollectionId = data[0].id;

        this.paymentService.getBillCompetition(competitionId).subscribe((dataBill: any) => {});
      }
    });
  }

  public openWithSystemBrowser(url: string) {
    let target = '_system';
    let browser = this.iab.create(url, target, this.options);
    MessageDisplayUtil.showMessageToast(
      'Browser closed',
      this.platform,
      this.toastCtl,
      3000,
      'bottom'
    );

    browser.on('exit').subscribe(
      () => {
        MessageDisplayUtil.showMessageToast(
          'exit Browser closed',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
      },
      err => {}
    );
    browser.close();
  }
  public openWithInAppBrowser(url: string) {
    let target = '_blank';
    let browser = this.iab.create(url, target, this.options);
    MessageDisplayUtil.showMessageToast(
      'Browser closed',
      this.platform,
      this.toastCtl,
      3000,
      'bottom'
    );

    browser.on('exit').subscribe(
      () => {
        MessageDisplayUtil.showMessageToast(
          'exit Browser closed',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
      },
      err => {}
    );
    browser.close();
  }
  public openWithCordovaBrowser(url: string) {
    let target = '_self';
    let browser = this.iab.create(url, target, this.options);
    MessageDisplayUtil.showMessageToast(
      'Browser closed',
      this.platform,
      this.toastCtl,
      3000,
      'bottom'
    );

    browser.on('exit').subscribe(
      () => {
        MessageDisplayUtil.showMessageToast(
          'exit Browser closed',
          this.platform,
          this.toastCtl,
          3000,
          'bottom'
        );
      },
      err => {}
    );
    browser.close();
  }

  // this.getRemoteCollections(data.collectionId);
  //         }else if(data.type === 'getLocalCollections') {
  //             this.getLocalCollections(data.collectionId);
  //         } else if(data.type === 'getBill') {
  //             this.getBill(data.billId);
  //         } else if(data.type === 'createBill') {
  //             this.createBill(data.collectionId);
  //         } else if(data.type === 'createRemoteBill') {
  //             this.createRemoteBill(data.collectionId);
}
